import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appAlphabetic]'
})
export class AlphabeticDirective {
  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input', ['$event']) onInput(event: Event): void {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const inputValue: string = inputElement.value;
    const alphabeticValue = inputValue.replace(/[^a-zA-Z\s]/g, '');

    // Update DOM
    inputElement.value = alphabeticValue;

    // Update form control value
    if (this.control?.control) {
      this.control.control.setValue(alphabeticValue, { emitEvent: false });
    }
  }
}


//     @HostListener('input', ['$event']) onInput(event: Event): void {
//         const inputElement = this.el.nativeElement as HTMLInputElement;
//         const inputValue: string = inputElement.value;
//         // Remove non-alphabetic characters
//         const alphabeticValue = inputValue.replace(/[^a-zA-Z\s]/g, '');
//         inputElement.value = alphabeticValue;
//     }
